/* eslint prefer-promise-reject-errors: ["off"] */
import uuid4 from 'uuid/v4';

import { UNKNOWN_HTTP_ERROR_MESSAGE } from '../defaults';

import { simpleAjaxDispatch } from './http';
import { watchCorrelationId } from './longpoller';

export function submitScan(type, json) {
  const allData = { ...json, correlationId: uuid4() };

  const typeParts = type.split('_GENACC');

  let finalValue = null;
  let sawNoop = false;
  return (dispatch, getState) => new Promise((resolve, reject) => {
    const watchProm = watchCorrelationId(allData.correlationId, (err, value) => {
      if (err) return;
      // routingKey is like event.rpc.result.<ev>.<qualName>
      const event = value.routingKey.split('.')[3];
      if (event === 'complete') {
        if (finalValue && finalValue.event === 'value') {
          resolve(JSON.parse(finalValue.content));
        } else if (finalValue && finalValue.event === 'error') {
          reject(JSON.parse(finalValue.content));
        } else if (sawNoop) {
          // Scan was accepted but queued for async processing (only start +
          // noop emitted, no value/error). Resolve with a sentinel so the
          // caller can render a "queued" success state.
          resolve({ queued: true });
        } else {
          reject({ _errors: [UNKNOWN_HTTP_ERROR_MESSAGE] });
        }
      } else if (event === 'value' || event === 'error') {
        finalValue = value;
        finalValue.event = event;
      } else if (event === 'noop') {
        sawNoop = true;
      }
    })
      .then(() => {
        simpleAjaxDispatch(`/scan/${typeParts[0]}`, 'submitScan', {
          json: allData, method: 'POST',
        })(dispatch, getState)
          .then(action => {
            if (action.failed) {
              reject(action.data);
            }
          })
          .catch(err => reject({ _errors: [err] }))
          .finally(() => watchProm.cancel());
      })
      .catch(() => { });
  });
}

export function fetchVevoCountries() {
  return simpleAjaxDispatch('/vevo/countries', 'fetchVevoCountries');
}
